import { trackForwardedComponent } from '../../../util/trackComponent.js';
import { SkeletonLoader as SkeletonLoaderMemoized } from './Skeleton.js';
import './Skeleton.types.js';

/**
 * @deprecated SkeletonLoader is deprecated and being replaced by SkeletonLoaderV3.
 * Skeleton represents a loading state of an underlying component. */
var SkeletonLoaderWithTracking = trackForwardedComponent(SkeletonLoaderMemoized);

export { SkeletonLoaderWithTracking as SkeletonLoader };
//# sourceMappingURL=external.js.map
